<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editEmail.txt1')}}</span>
        <span>{{$t('editEmail.txt2')}} / {{$t('editEmail.txt3')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{!isNext?$t('editEmail.txt3'):$t('editEmail.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editEmail.txt6')}}</div>
          <div v-if="!isNext" class="searchBtn verification" @click="nextEmailForm('emailForm')">{{$t('editEmail.txt7')}}</div>
          <div v-else class="searchBtn" @click="confirmEmailForm('newEmailForm')">{{$t('editEmail.txt8')}}</div>
        </div>
      </div>
      <div class="editForm emailForm" v-if="!isNext">
        <el-form :model="emailForm" :rules="editEmailRules" ref="emailForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editEmail.txt4')" prop="email">
            <el-input :disabled="isEmail"
            :placeholder="$t('editEmail.txt9')"
            v-model="emailForm.email">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('editEmail.txt10')" prop="code">
          <div class="handleBoxSeach flexCenter">
            <el-input :placeholder="$t('editEmail.txt11')"  v-model="emailForm.code"></el-input>
            <div>
              <div v-if="showEmail == 1" class="searchBtn">{{$t('editEmail.txt12')}}{{countEmail}}{{$t('editEmail.txt13')}}</div>
              <div v-else class="searchBtn" @click="onSendEmailCode">{{showEmail == 0?$t('editEmail.txt14'):$t('editEmail.txt15')}}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="editForm emailForm" v-else>
        <el-form :model="newEmailForm" :rules="editNewEmailRules" ref="newEmailForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editEmail.txt16')" prop="email">
            <el-input
            :placeholder="$t('editEmail.txt17')"
            v-model="newEmailForm.email">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      var checkEmail = (rule, value, callback) => {
        const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
        if (!value) {
          return callback(new Error(this.$t('editEmail.txt18')));
        }
        setTimeout(() => {
          if (mailReg.test(value)) {
            callback()
          } else {
            callback(new Error(this.$t('editEmail.txt19')))
          }
        }, 100)
         callback();
      }
      return {
        queryData:{},
        id:'',
        isNext:false,
        // 邮箱校验
        editEmailRules:{
         email: [
          {required:true,validator:checkEmail,trigger:'blur'},
         ],
         code:[
         { required: true, message: this.$t('editEmail.txt20'), trigger: 'blur' }
         ],
       },
       emailForm: {},//编辑参数
       showEmail:0,
       countEmail:0,
       timerEmail: null,
       isEmail:false,//判断是否存在邮箱
       newEmailForm:{},//新邮箱参数
       // 新邮箱校验
        editNewEmailRules:{
         email: [
         {required:true,validator:checkEmail,trigger:'blur'},
         ],
       },
     };
   },
   created() {
    this.infoDetail();
  },
  methods: {
     // 获取用户信息
      async infoDetail() {
        const { data: res } = await this.$http.get('/user/info/detail');
        this.queryData = {
          ...res.result
        }
        if(this.queryData.email){
          this.isEmail = true;
          this.emailForm.email = this.queryData.email;
        }
      },
      onBack(){
        this.$router.go(-1);
      },
      // 校验进入下一步
      nextEmailForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.checkCode();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
       // 个人中心-校验验证码
		async checkCode() {
			let data = {
        code:this.emailForm.code,
        type:2
      }
			const { data: res } = await this.$http.get("/user/info/checkCode?" + qs.stringify(data));
			if (!res.success) {
				return this.$message.error(res.message);
			}
      this.isNext = true;
		},
      // 绑定邮箱
      confirmEmailForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.savaEmail();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 个人中心-绑定邮箱
		async savaEmail() {
			let data = {
        code:this.emailForm.code,
        email :this.emailForm.email,
        userId:localStorage.userId
      }
			const { data: res } = await this.$http.get("/user/info/savaEmail?" + qs.stringify(data));
			if (!res.success) {
				return this.$message.error(res.message);
			}
      this.onBack();
		},
      // 发送邮箱验证码
      async onSendEmailCode(){
        let email = this.emailForm.email;
        var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if(!reg.test(email)){
          return this.$message.error(this.$t('editEmail.txt19'));
        }
        const { data: res } = await this.$http.get("/user/info/getCodeByEmail?email="+email);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          message: res.message,
          type: 'success'
        });
              const times = 60; // 倒计时时间
              if (!this.timerEmail) {
                this.countEmail = times;
                this.showEmail = 1;
                this.timerEmail = setInterval(() => {
                  if (this.countEmail > 0 && this.countEmail <= times) {
                    this.countEmail--;
                  } else {
                    this.showEmail = 2;
                    clearInterval(this.timerEmail);
                    this.timerEmail = null;
                  }
                }, 1000)
              }   
            },
          },
        };

      </script>

      <style lang="less" scoped>

        .handleBtn{
          padding: 0;
        }
        .userPage{
          /deep/ .el-upload__input{
            display: none !important;
          }
          .searchBtn{
            min-width: 130px !important;
          }
          .verification{
            min-width: 88px !important;
          }
          .handleBoxSeach{
            background-color: #F4F4F4 !important;
          }
          /deep/ .el-date-editor .el-range-separator{
            margin-top: -5px;
            width: 8%;
          }
          .contactTitle{
            margin-bottom: 40px;
          }
          .contactTitle span{
            margin-right: 30px;
            cursor: pointer;
            font-size: 30px;
            font-weight: 500;
            color: #222222;
          }
          .w350{
            width: 350px;
          }
          .tips{      
            font-size: 1.4rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #98B9FF;
            margin-top: -10px;
          }
          .emailForm{
            width: 50%;
            margin: 30px auto 260px auto;
            display: block;
            .handleBoxSeach{
              width: 100%;
            }
          }
        }

      </style>
